module.exports = __webpack_public_path__ + "img/2022-23.8aac0a85.jpg";